<template>
    <div class="row marketPowerExpired-row">
        <div class="control-sectionExpired">
            <h5 id="powerTitleExp">Power Expired</h5>
            <div class="form-row form-row-powerExp">
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplProductPowerExp' id="powerProductExp" name="powerProductExp" :change='onProductPowerExp' :index="selectDefault" :enabled="true" :dataSource='productPowerExp' :fields="{text: 'name', value: 'id' }" placeholder="Product" floatLabelType='Auto'></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref="dplTradablePeriodExp" id='tradablePeriodExp' name="tradablePeriodExp" :change='onPeriodPowerExp' :index="selectDefault" :enabled="true" floatLabelType="Auto" :dataSource='tradablePeriodsExp' :fields="{text: 'name', value: 'id' }" placeholder="Tradeable Period"></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplYearExp' id="yearPowerExp" name="yearPowerExp" :enabled="true" :change='onYearExp' v-model="selectedYearExp" :index="selectDefault" :dataSource='yearPowerExp' placeholder="Year" floatLabelType='Auto'></ejs-dropdownlist>
                </div>
                <div class="form-group col-md-3">
                    <ejs-dropdownlist ref='dplStateExp' id="stateExp" name="stateExp" :change='onStateExp' v-model="selectedStateExp" :index="selectDefault" :enabled="true" :dataSource='stateDataExp' :fields="{text: 'name', value: 'id' }" placeholder="State - Price Area" floatLabelType='Auto'></ejs-dropdownlist>
                </div>
            </div>
            <div id="noDataExp" ref="noDataExp" class="chartPowerNoDataExp" align='center'>
                <img src="../../../../public/img/NoData.jpg" />
            </div>

            <div class="chartPower" align='center'>
                <ejs-stockchart id="stockchartcontainerPowerExpired"
                                width='80%'
                                ref="schPowerExp"
                                :primaryXAxis="primaryXAxis"
                                :primaryYAxis="primaryYAxis"
                                :crosshair="crosshair"
                                :title="title"
                                :tooltip="tooltip"
                                :enableSelector="enableSelector"
                                :trendlineType="trendlineType"
                                :indicatorType="indicators"
                                :seriesType="seriesType"
                                :exportType="exportType"
                                :theme="theme">
                    <e-stockchart-periods>
                        <e-stockchart-period intervalType="Months" interval="1" text="1M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="3" text="3M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Months" interval="6" text="6M"></e-stockchart-period>
                        <e-stockchart-period intervalType="Years" interval="1" text="1Y" selected="true"></e-stockchart-period>
                        <e-stockchart-period text="YTD"></e-stockchart-period>
                        <e-stockchart-period text="All"></e-stockchart-period>
                    </e-stockchart-periods>
                    <e-stockchart-series-collection>
                        <e-stockchart-series :dataSource="seriesDataPowerExp" type="Spline" xName='date' yName="price" fill="#485696"></e-stockchart-series>
                    </e-stockchart-series-collection>
                </ejs-stockchart>
            </div>
            <div id="hiddenDivPowerExp" style="display: none;" class="__web-inspector-hide-shortcut__">
                <ejs-grid id="chartHiddendataPowerExp"
                          :dataSource="chartHiddenSourcePowerExp"
                          ref="chartHiddenGridPowerExp"
                          :allowPaging="true"
                          :pageSettings='pageSettings'
                          :allowExcelExport='true'
                          :toolbarClick='toolbarClickPowerExp'
                          :toolbar='toolbarOptionsPowerExp'
                          :visible="false">
                    <e-columns>
                        <e-column field='id' :disableHtmlEncode='false' headerText='Id' :isPrimaryKey='true' :visible="false" textAlign='Left'></e-column>
                        <e-column field='ricName' :disableHtmlEncode='false' headerText='Ric' textAlign='Left' width="100px"></e-column>
                        <e-column field='priceAreaName' :disableHtmlEncode='false' headerText='State - Price Area' textAlign='Left' width="120px"></e-column>
                        <e-column field='productName' :disableHtmlEncode='false' headerText='Product' textAlign='Left' width="120px"></e-column>
                        <e-column field='periodName' :disableHtmlEncode='false' headerText='Period' textAlign='Left' width="120px"></e-column>
                        <e-column field='date' :disableHtmlEncode='false' headerText='Date' :format='dateFormatOptions' type="date" textAlign='Left' width="120px"></e-column>
                        <e-column field='price' :disableHtmlEncode='false' headerText='Price' textAlign='Left' width="100px"></e-column>
                        <e-column field='tradingUnitName' :disableHtmlEncode='false' headerText='Unit' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="btn-excelExp">
                <ejs-button id="powerExpbtn" v-on:click.native='toolbarClickPowerExp'>Export Data</ejs-button>
            </div>
            <div ref='spinnerEle' id="spinner"></div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import {
        StockChartPlugin, DateTime, CandleSeries, RangeTooltip, LineSeries, SplineSeries,
        HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator, BollingerBands,
        TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, Crosshair, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
    } from "@syncfusion/ej2-vue-charts";
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { GridPlugin, Page, Toolbar, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import SyncHelper from '@/common/syncfusion';
    import periodConversion from '@/common/periodConversion';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(ButtonPlugin);
    Vue.use(StockChartPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(GridPlugin);

    let selectedTheme = location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    let theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");

    export default Vue.extend({
        created() {
            this.populateYearsPowerExp("Calendar", "Baseload");
            this.populateStateAndRicId("Calendar", "Baseload", new Date().getFullYear() - 1);
        },
        data: function () {
            return {
                mppdDateVal: dates.addDays(new Date(), -1),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                mppdPowerRates: [],
                mppdGasRates: [],
                powerRates: [],
                seriesDataPowerExp: [],
                yearPowerExp: [],
                stateDataExp: [],
                chartHiddenSourcePowerExp: [],
                selectDefault: 0,
                selectedYearExp: 0,
                selectedStateExp: 0,
                pageSettings: { pageSize: 8 },
                toolbarOptionsPowerExp: ['Export Data'],
                selection: { type: 'Multiple' },
                exportType: ["JPEG", "PNG", "PDF", "SVG", "Print"],
                theme: theme,
                //Initializing Primary X Axis
                primaryXAxis: {
                    visible: true,
                    valueType: 'DateTime'

                },
                //Initializing Primary Y Axis
                primaryYAxis:
                {
                    visible: true,
                    majorTickLines: { color: "transparent", width: 0 },
                    labelPosition: 'Outside'
                },

                enableSelector: true,
                trendlineType: [],
                indicators: [],
                seriesType: [],
                theme: 'Bootstrap',
                tooltip: {
                    enable: true, header: ' ',
                    format: '<b>${point.x} : ${point.y}</b>'
                },

                crosshair: { enable: true },
                chartArea: {
                    border: {
                        width: 0
                    }
                },
                title: " ",
                palettes: ["#001c55", "#8f857d"]
            };
        },

        provide: {
            stockChart: [
                DateTime, Crosshair, RangeTooltip, LineSeries, SplineSeries, CandleSeries, HiloOpenCloseSeries, HiloSeries, RangeAreaSeries, Trendlines, EmaIndicator, RsiIndicator,
                BollingerBands, TmaIndicator, MomentumIndicator, SmaIndicator, AtrIndicator, AccumulationDistributionIndicator, MacdIndicator, StochasticIndicator, Export, Tooltip
            ],
            grid: [Page, Toolbar, ExcelExport]

        },
        mounted() {
            //createSpinner({ target: this.$refs.spinnerEle });
            //showSpinner(this.$refs.spinnerEle);
        },
        methods: {
            toolbarClickPowerExp: function (args) {

                let excelExportProperties = {
                    fileName: "Export Chart Power Expired.xlsx",
                    theme:
                    {
                        header: {
                            fontName: 'Arial', fontColor: '#001c55'
                        },
                        record: {
                            fontName: 'Arial', fontColor: '#4d4d4d'
                        },
                        caption: {
                            fontName: 'Arial', fontColor: '#4d4d4d'
                        }
                    }
                };
                this.$refs.chartHiddenGridPowerExp.excelExport(excelExportProperties);

            },
            onYearExp: function (args) {
                if (args.isInteracted == true) {
                    showSpinner(document.getElementById('mainSpinner'))
                }
                if (this.$refs.dplStateExp.ej2Instances.itemData != null && this.$refs.dplProductPowerExp.ej2Instances.itemData != null) {
                    var product = this.$refs.dplProductPowerExp.ej2Instances.itemData.name;
                    var ricId = this.$refs.dplStateExp.ej2Instances.itemData.id;
                    if (ricId != undefined && args.value != null) {

                        var splitPeriod = args.value.split('-');
                        var indicatorSplit = splitPeriod[0];

                        var indicator = "";
                        if (indicatorSplit.includes("Q")) {
                            indicator = indicatorSplit;
                        } else {
                            indicator = periodConversion.convertPeriod(indicatorSplit);
                        }
                        const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                        this.fetchPowerDataChartExp(ricId, indicator, year, product);
                    }
                }
                hideSpinner(document.getElementById('mainSpinner'))
            },
            onStateExp: function (args) {
                if (args.isInteracted == true) {
                    showSpinner(document.getElementById('mainSpinner'))
                    var product = this.$refs.dplProductPowerExp.ej2Instances.itemData.name;
                    var yearPeriodExp = this.$refs.dplYearExp.ej2Instances.itemData;
                    var splitPeriod = yearPeriodExp.split('-');


                    var indicatorSplit = splitPeriod[0];
                    var indicator = "";
                    if (indicatorSplit.includes("Q")) {
                        indicator = indicatorSplit;
                    } else {
                        indicator = periodConversion.convertPeriod(indicatorSplit);
                    }


                    const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                    this.fetchPowerDataChartExp(args.itemData.id, indicator, year, product);
                }
            },
            onPeriodPowerExp: function (args) {

                var product = this.$refs.dplProductPowerExp.ej2Instances.itemData.name;
                var period = this.$refs.dplYearExp;
                period.$el.value = "";
                if (args.itemData.name == 'Calendar') {
                    period.ej2Instances.placeholder = "Select Year"
                }
                if (args.itemData.name == 'Month') {
                    period.ej2Instances.placeholder = "Select Month"
                }
                if (args.itemData.name == 'Quarter') {
                    period.ej2Instances.placeholder = "Select Quarter"
                }
                if (args.itemData.name == 'Season') {
                    period.ej2Instances.placeholder = "Select Season"
                }
                var yearPeriodExp = this.$refs.dplYearExp.ej2Instances.itemData;
                if (yearPeriodExp != null) {
                    var splitPeriod = yearPeriodExp.split('-');


                    const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                    this.populateStateAndRicId(args.itemData.name, product, year);

                }
                this.populateYearsPowerExp(args.itemData.name, product);
            },
            onProductPowerExp: function (args) {

                var indicatorReal = this.$refs.dplTradablePeriodExp.ej2Instances.itemData.name;

                var yearPeriodExp = this.$refs.dplYearExp.ej2Instances.itemData;
                var splitPeriod = yearPeriodExp.split('-');

                const year = parseInt(new Date().getFullYear().toString().slice(0, 2) + splitPeriod[1]);
                this.populateStateAndRicId(indicatorReal, args.itemData.name, year);
                this.populateYearsPowerExp(indicatorReal, args.itemData.name);



            },
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                    document.getElementById("powerExpbtn").style.display = 'none';
                    
                }

            },
            fetchPowerDataChartExp(id, indicator, year, product) {
                apis.protectedApi(`${urls.apiBaseUrl}MarketPricingPerDay/FromDateChart?date=${this.mppdDateVal.toISOString().split('T')[0]}&id=${id}&indicator=${indicator}&year=${year}&product=${product}`).then(fxr => {
                    let temp = [];
                    let tempChartPowerExp = [];
                    for (var i = 0; i < fxr.data.result.length; i++) {
                        temp.push(fxr.data.result[i]);

                        let chartRatePowerExp = {

                            id: fxr.data.result[i].ricId,
                            ricName: fxr.data.result[i].fullRicName,
                            stateName: fxr.data.result[i].stateName,
                            priceAreaName: fxr.data.result[i].priceAreaName,
                            productName: fxr.data.result[i].productName,
                            periodName: fxr.data.result[i].periodSpanName == null ? fxr.data.result[i].periodName : fxr.data.result[i].periodSpanName,
                            price: fxr.data.result[i].price.toFixed(3),
                            tradingUnitName: fxr.data.result[i].tradingUnitName,
                            date: new Date(fxr.data.result[i].date)
                        }
                        tempChartPowerExp.push(chartRatePowerExp);
                    }
                    if (temp.length == 0) {
                        this.$refs.schPowerExp.$el.style.display = "none";
                        document.getElementById("noDataExp").style.display = "block";

                    } else {
                        this.$refs.schPowerExp.$el.style.display = "block";
                        document.getElementById("noDataExp").style.display = "none";
                    }
                    this.seriesDataPowerExp = temp;
                
                    this.chartHiddenSourcePowerExp = tempChartPowerExp;
                    hideSpinner(document.getElementById('mainSpinner'))

                }).catch(
                    response => {
                        this.handleError(response);
                        //hideSpinner(this.$refs.spinnerEle);
                        hideSpinner(document.getElementById('mainSpinner'))

                    }

                );

            },
            populateStateAndRicId(indicator, product, year) {

                showSpinner(document.getElementById('mainSpinner'))
                apis.protectedApi(`${urls.apiBaseUrl}utils/getSateExpMarket?date=${this.mppdDateVal.toISOString().split('T')[0]}&year=${year}&indicator=${indicator == undefined ? "Calendar" : indicator}&product=${product == undefined ? "Baseload" : product}`).then(state => {

                    this.mppdPowerRates = [];
                    let temp = [];
                    for (var i = 0; i < state.data.result.length; i++) {
                        temp.push(state.data.result[i]);
                    }
                    this.stateDataExp = temp;

                    if (this.selectedStateExp == 0) {
                        setTimeout(() => {
                            this.selectedStateExp = this.stateDataExp[0].id;
                            // Load chart on first load with defaults
                            this.fetchPowerDataChartExp(this.stateDataExp[0].id, indicator, year, product);
                        }, 800)
                    }

                    this.checkPermissionOnUser();
                    hideSpinner(document.getElementById('mainSpinner'))
                }).catch(
                    response => {
                        this.handleError(response);
                        hideSpinner(document.getElementById('mainSpinner'))
                    }
                );

            },
            populateYearsPowerExp: function (indicator, product) {
                showSpinner(document.getElementById('mainSpinner'))
                apis.protectedApi(`utils/productYearsExp?date=${this.mppdDateVal.toISOString().split('T')[0]}&indicator=${indicator}&product=${product == undefined ? "Baseload" : product}`)
                    .then(response => {
                        let temp = [];
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].name == "Calendar") {
                                response.data[i].name = "CAL"
                            }

                            if (response.data[i].periodName == "Month" || response.data[i].periodName == "Season") {
                                response.data[i].name = response.data[i].name.slice(0, 3);
                            }
                            var yearString = response.data[i].year.toString();
                            var yearSlice = yearString.slice(2);
                            var name = response.data[i].name + "-" + yearSlice;

                            temp.push(name);

                        }
                        this.yearPowerExp = temp;
                        if (this.selectedYearExp == 0) {
                            setTimeout(() => {
                                this.selectedYearExp = this.yearPowerExp[0];
                            }, 800)

                        }
                        // hideSpinner(this.$refs.spinnerEle);
                        hideSpinner(document.getElementById('mainSpinner'))
                    }).catch(e => {
                        //hideSpinner(this.$refs.spinnerEle);
                        hideSpinner(document.getElementById('mainSpinner'))
                    });

            },

        },
        computed:
        {
            productPowerExp() {
                return SyncHelper.getDataManager("utils/productPower");
            },
            tradablePeriodsExp() {
                return SyncHelper.getDataManager("utils/Tradableperiods");
            },
        }

    });
</script>
<style>

    #stockchartcontainerPowerExpired_Secondary_Element_Secondary_Element{
        left:69px!important;
    }
    .chartPower {
        width: auto;
    }

    #stockchartcontainerPowerExpired_stock_border {
        width: 80%!important;
    }

    #stockchartcontainerPowerExpired_Secondary_Element {
        width: 96%;
    }

    @media screen and (max-width: 1746px) {
        #stockchartcontainerPowerExpired_Secondary_Element {
            width: 80%;
        }
    }

    .fx-price-padding {
        padding-top: 30px;
    }

    .e-btn-group-powh {
        margin: 0px 20px 20px 20px;
        width: 330px;
    }


    .control-sectionExpired {
        background-color: white;
        border: 1px solid lightgrey;
        border-radius: 5px;
        margin: 5px 0px 35px 10px;
        width: 100%;
    }

    .btn-category {
        width: auto !important;
    }

    .marketPowerExpired-row {
        display: flex;
        background-color: white;
        padding: 25px 20px 0px 0px;
      
    }

    .colorGreen {
        color: green;
    }
    #noDataExp {
        display: none;
    }
    #stockchartcontainerPowerExpired_stock_border {
        border: 0px solid rgb(221, 221, 221) !important;
    }
    #powerTitleExp {
        padding: 10px 0px 0px 10px;
    }
    .form-row-powerExp {
        display: flex !important;
        margin: 0px 5px 0px 5px;
        flex-wrap: nowrap!important;
    }
    .btn-excelExp {
        padding: 10px 10px 10px 10px;
    }
    .e-toolbar-right > div:nth-child(3) {
        display: none !important;
    }

</style>